import React from 'react';
import { MainContentContainer, MainSection } from '../OtherPages.styles';
import SideContainerComponent from '../SideContainer.component';
import InfoWeCollect from './InfoCollected';
import UsePersonalInfo from './UsePersonalInfo';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import SharingPersonalInfo from './SharingPersonalInfo';
import AcceptanceOfTerms from './AcceptanceOfTerms';
import ContentProperty from './ContentProperty';
import ProhibitedActivites from './ProhibitedActivities';
import PrivacyPolicySummary from './Summary';
import PrivacyPolicyHeader from './HeaderPrivacyPolicy';
import Security from './Security';
import YourRights from './YourRights';
const PrivacyPolicy = () => {
  return (
    <MainContentContainer>
      <HelmetHelper
        title="Privacy Policy"
        description="Privacy Policy for Yoda Safety Services"
      />
      <SideContainerComponent />
      <MainSection>
        <h2>Privacy Policy</h2>
        <PrivacyPolicyHeader />
        <InfoWeCollect />
        <UsePersonalInfo />
        <YourRights />
        <SharingPersonalInfo />
        <AcceptanceOfTerms />
        <ContentProperty />
        <ProhibitedActivites />
        <Security />
        <PrivacyPolicySummary />
      </MainSection>
    </MainContentContainer>
  );
};

export default PrivacyPolicy;
